import { useState, useCallback } from 'react';

export type T202Mode = 'browse' | 'add' | 'edit';

export function useT202Mode() {
  const [mode, setMode] = useState<T202Mode>('browse');

  const isEditing = mode !== 'browse';

  const enterAdd = useCallback(() => setMode('add'), []);
  const enterEdit = useCallback(() => setMode('edit'), []);
  const enterBrowse = useCallback(() => setMode('browse'), []);

  return {
    mode,
    setMode,
    isEditing,
    enterAdd,
    enterEdit,
    enterBrowse,
  };
}
